"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideBySideColumn = exports.SideBySideColumnInner = void 0;
var mobx_react_1 = require("mobx-react");
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var WidgetManager_1 = require("Project/QwilrEditor/WidgetManager");
var EditorTypes_1 = require("Project/QwilrEditor/EditorTypes");
var ImagePlaceholder_1 = require("./ImagePlaceholder");
var slate_1 = require("slate");
var Types_1 = require("@CommonFrontendBackend/ContentTokens/Types");
var DropLocationStore_1 = require("Project/Stores/DropLocationStore/DropLocationStore");
var mobx_1 = require("mobx");
var DragUtils_1 = require("Project/QwilrEditor/Behaviours/DragUtils");
var SideBySideContext_1 = require("./SideBySideContext");
var inversify_react_1 = require("inversify-react");
var lodash_1 = require("lodash");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var SideBySideColumnInner = (function (_super) {
    __extends(SideBySideColumnInner, _super);
    function SideBySideColumnInner() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.handleDragOverColumn = function (event) {
            var _a = _this.props, dragStore = _a.dragStore, dropLocationStore = _a.dropLocationStore;
            if (!_this.renderPlaceholderForColumn) {
                return;
            }
            event.preventDefault();
            event.stopPropagation();
            if (!_this.placeholderDropEnabled) {
                return;
            }
            if (!(0, DragUtils_1.checkIsImageDragEvent)(dragStore, event)) {
                return;
            }
            dropLocationStore.setDropLocation({
                path: _this.findImagePlaceholderInsertionPath(),
                editorId: _this.props.widgetManager.editor.uniqueId,
                type: DropLocationStore_1.DropLocationType.TwoColumnPlaceholder,
            });
        };
        _this.handlePickImage = function () {
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent(Types_1.WidgetBlockType.SideBySide, {
                action: EditorTypes_1.SideBySideActionType.PickImage,
                path: _this.findSideBySidePath(),
            }));
        };
        _this.handleDismissImagePlaceholder = function () {
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent(Types_1.WidgetBlockType.SideBySide, {
                action: EditorTypes_1.SideBySideActionType.DismissPlaceholder,
                path: _this.findSideBySidePath(),
            }));
        };
        _this.findSideBySidePath = function () {
            var _a = _this.props, widgetManager = _a.widgetManager, element = _a.element;
            var colPath = widgetManager.getPath(element);
            return colPath.slice(0, colPath.length - 1);
        };
        _this.findImagePlaceholderInsertionPath = function () {
            return _this.props.widgetManager.getPath(_this.props.element).concat([0]);
        };
        return _this;
    }
    SideBySideColumnInner.prototype.render = function () {
        var _a = this.props, attributes = _a.attributes, children = _a.children;
        var renderPlaceholderForColumn = this.renderPlaceholderForColumn;
        return (react_1.default.createElement("div", __assign({ onDragOver: this.handleDragOverColumn }, attributes),
            renderPlaceholderForColumn && (react_1.default.createElement(ImagePlaceholder_1.ImagePlaceholder, { activeDropzone: this.placeholderIsActiveDropzone, dropEnabled: this.placeholderDropEnabled, onPickImage: this.handlePickImage, onDismiss: this.handleDismissImagePlaceholder })),
            react_1.default.createElement("div", { className: (0, classnames_1.default)("side-by-side__col-content", {
                    "side-by-side__col-content--hidden": renderPlaceholderForColumn,
                }), "data-layout-node": "true" }, children)));
    };
    Object.defineProperty(SideBySideColumnInner.prototype, "renderPlaceholderForColumn", {
        get: function () {
            var _a = this.props, columnIdx = _a.columnIdx, placeholderIndex = _a.placeholderIndex;
            return columnIdx === placeholderIndex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SideBySideColumnInner.prototype, "placeholderIsActiveDropzone", {
        get: function () {
            var _a = this.props, dropLocationStore = _a.dropLocationStore, widgetManager = _a.widgetManager;
            var dropLocation = this.props.dropLocationStore.dropLocation;
            if (!dropLocation) {
                return false;
            }
            if (dropLocation.type !== DropLocationStore_1.DropLocationType.TwoColumnPlaceholder) {
                return false;
            }
            return (dropLocationStore.dropLocation.editorId === widgetManager.editor.uniqueId &&
                slate_1.Path.equals(this.findImagePlaceholderInsertionPath(), dropLocation.path));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SideBySideColumnInner.prototype, "placeholderDropEnabled", {
        get: function () {
            return this.props.usingSidebarImages;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], SideBySideColumnInner.prototype, "renderPlaceholderForColumn", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], SideBySideColumnInner.prototype, "placeholderIsActiveDropzone", null);
    SideBySideColumnInner = __decorate([
        mobx_react_1.observer
    ], SideBySideColumnInner);
    return SideBySideColumnInner;
}(react_1.default.Component));
exports.SideBySideColumnInner = SideBySideColumnInner;
var SideBySideColumn = function (props) {
    var sbsContext = (0, react_1.useContext)(SideBySideContext_1.SideBySideContext);
    var dropLocationStore = (0, inversify_react_1.useInjection)("dropLocationStore");
    var widgetManager = (0, inversify_react_1.useInjection)(WidgetManager_1.WidgetManager);
    var dragStore = (0, inversify_react_1.useInjection)("dragStore");
    var usingFeature = (0, inversify_react_1.useInjection)("usingFeature");
    var path = widgetManager.getPath(props.element);
    var columnIdx = (0, lodash_1.last)(path) + 1;
    return (react_1.default.createElement(SideBySideColumnInner, __assign({}, props, sbsContext, { dropLocationStore: dropLocationStore, columnIdx: columnIdx, widgetManager: widgetManager, dragStore: dragStore, usingSidebarImages: usingFeature(FeatureFlag_1.default.SidebarImages) })));
};
exports.SideBySideColumn = SideBySideColumn;
